// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1YL3C","upload":"Small_upload__3xxCP","imageWrap":"Small_imageWrap__1xmKX","removeBtn":"Small_removeBtn__3jgVT"};